import React from 'react';
import thermostat from '../assests/thermostat.mp4' // Assuming you have an image file
import thermostat_case from '../assests/thermostat_case.jpeg'
import prototype from '../assests/prototype.jpeg'
import airflow from '../assests/airflow.mp4'
import waterflow from '../assests/waterflow.mp4'


const Praxis = () => {
  return (
    <div className="w-full min-h-screen text-blue-light bg-gray-100 pt-[120px]">
      <div className="max-w-[900px] mx-auto p-8 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <h1 className="text-4xl font-bold inline border-b-4 border-blue-dark text-blue-dark">
            ESC204 Praxis III (2nd Year Course) 
          </h1>
          <p className="py-6 text-gray-700">
            Group project to prototype a heat exchanger using cool ocean water.
          </p>
        </div>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark border-b-2">Software</h2>
          <p className="py-4 text-gray-600">
            As part of this team, I worked on the software side of tempertaure control.
            Used a relay to switch a pump and fan on/off, depending on the tempearture input from a thermistor.
            The states were detemerined by bang-bang control.
          </p>

            <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Video */}
            <div className="w-full md:w-auto h-80 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={thermostat} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>

            {/* Text/Image Section */}
            <div className="w-full h-80 md:w-1/3 text-gray-600 shadow-lg">
                {/* <h2 className="text-2xl font-semibold text-blue-dark">Development Process</h2> */}
                {/* <p className="py-4"> Our development process involved several  </p> */}
                <div
                style={{ backgroundImage: `url(${thermostat_case})` }}
                className="w-full h-full bg-cover bg-center rounded"
                />
            </div>
          </div>

        </div>

        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark border-b-2">Final Product</h2>
            <p className="py-4 text-gray-600">
            </p>

            <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Text/Image Section */}
            <div className="w-full h-96 md:w-6/12 text-gray-600 shadow-lg">
                {/* <h2 className="text-2xl font-semibold text-blue-dark">Development Process</h2> */}
                {/* <p className="py-4"> Our development process involved several  </p> */}
                <div
                style={{ backgroundImage: `url(${prototype})` }}
                className="w-full h-full bg-cover bg-center rounded"
                />
            </div>

            {/* Video */}
            <div className="w-full md:w-3/12 h-96 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={airflow} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>

            {/* Video */}
            <div className="w-full md:w-3/12 h-96 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={waterflow} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>

          </div>

        </div>
    
      </div>
    </div>
  );
};

export default Praxis;
